import { initializeTracing } from '@flywire/flotel-js';
import React, { createContext, useEffect } from 'react';

import {
  FF_WEB_VITALS,
  PERMANENT_COOKIE_NAME,
  SENTRY_ENVIRONMENT,
} from 'constants/index';
import { usePeertransferFlags } from 'hooks/usePeertransferFlags/usePeertransferFlags';
import { cookies } from 'utils/cookies/cookies';

const TracingContext = createContext<undefined>(undefined);

function TracingProvider({ children }: { children: React.ReactNode }) {
  const fingerprint = cookies.read(PERMANENT_COOKIE_NAME) || 'no_fingerprint';
  const { data: flags } = usePeertransferFlags(FF_WEB_VITALS);
  const webVitalsEnabled = !!flags?.[FF_WEB_VITALS] === true;

  useEffect(() => {
    initializeTracingIfEnabled(webVitalsEnabled, fingerprint);
  }, [fingerprint, webVitalsEnabled]);

  return (
    <TracingContext.Provider value={undefined}>
      {children}
    </TracingContext.Provider>
  );
}

function initializeTracingIfEnabled(
  webVitalsEnabled: boolean,
  fingerprint: string,
) {
  const environment = SENTRY_ENVIRONMENT;

  const shouldInitialize =
    webVitalsEnabled &&
    environment &&
    environment !== '$ENVIRONMENT' &&
    environment !== 'local';

  if (!shouldInitialize) {
    return;
  }

  initializeTracing({
    serviceName: 'flywire-payex',
    env: environment,
    attributes: { fingerprint },
    // TODO we need to add the domains we want to trace
    allowedTracingDomains: [],
  });
}

export { TracingContext, TracingProvider };
